/** Normalize a repo path relative to the bridge or session/preview workspace root. */
export function normalizeRepoPathRelativeToWorkspaceRoot(pathRelativeToWorkspaceRoot: string): string {
  const normalized = pathRelativeToWorkspaceRoot.replace(/\\/g, '/').trim();
  return normalized === '' ? '.' : normalized;
}
